module.exports = __webpack_public_path__ + "static/media/logo.ff03dba6.svg";